// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"agent":{"f":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RentalNeedSearchResult_rentalNeed",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedPriceRange_rentalNeedV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedAreas_rentalNeedV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedPropertyAttributes_rentalNeedV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedAddedDate_rentalNeedV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedStatus_rentalNeedV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedLeaseAttributes_rentalNeedV5"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "Agent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AgentInfo_agent"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RentalNeedSearchResultTimestamp_rentalNeed"
    }
  ],
  "type": "RentalNeedV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
